import React from 'react';

import { Layout } from '@components/Layout';
import { useSearch } from '@hooks/useSearch';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { createStrings } from '@utils/local';
import * as t from 'io-ts';
import * as h from 'tyrann-io';

const strings = createStrings({
  ja: {
    title: '【D2D】無料アカウント作成｜中国貿易に特化した海上輸送システム',
    verifyEmail: (email: string) => (
      <>
        <span role="title">ご登録はまだ完了していません。</span>
        <br />
        <br />
        以下のメールアドレスにご本人確認用のメールを送信しました：
        <br />
        <br />
        <span>{email}</span>
        <br />
        <br />
        メールが届かない場合、メールアドレスに間違いがあるか、もしくは登録手続きが正しく完了していない可能性があります。
        <br />
        <br />
        その場合はお手数ですが、D2D MEMBERSの登録を再度やり直してくださいますようお願い致します。
        <br />
      </>
    ),
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  container: {
    ...common.flexColumn,
    backgroundColor: theme.palette.base[200],
    minHeight: '60vh',
    flex: 1,
  },
  content: {
    ...common.flexColumn,
    ...common.textAlignCenter,
    flex: 1,
    backgroundColor: theme.palette.base[200],
    paddingTop: 95,
    paddingLeft: 13,
    paddingRight: 13,
    paddingBottom: 80,
    fontSize: '14px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    },
  },
  verifyEmail: {
    ...common.fontWeight400,
    '& span': {
      ...common.normalText,
      ...common.fontWeight700,
    },
    '& span[role="title"]': {
      color: theme.palette.primary.main,
      ...common.normalText,
      ...common.fontWeight700,
    },
  },
}));

const query = t.type({
  email: h.omittable(t.string),
});

export const CreateAccountVerifyEmail: React.FC = () => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  const { search } = useSearch(query);

  return (
    <Layout title={strings.title}>
      <div className={classes.container}>
        <div className={classes.content}>
          <div className={classes.verifyEmail}>{strings.verifyEmail(search.email || '')}</div>
        </div>
      </div>
    </Layout>
  );
};
